@import 'fluid-divider.theme.less';

@fluid-divider: {}
